var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.computedClass }, [
    _c("main", { staticClass: "jade-container__main" }, [_vm._t("default")], 2),
    _vm.$slots.aside
      ? _c(
          "aside",
          { staticClass: "jade-container__aside" },
          [_vm._t("aside")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }